import { memo } from 'react';
import BulkWhatsAppMessages from '../../components/Bulk-WhatsApp-Messages/Index';

const Index = () => (
    <div className="flex flex-1 flex-col overflow-hidden px-2 md:px-4">
        <div className="flex-1 flex flex-col min-h-0 mt-2 overflow-hidden">
            <BulkWhatsAppMessages />
        </div>
    </div>
);

export default memo(Index);